import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { AppService } from '../../../../services/app.service';
import { ConfirmComponent } from './confirm.component';

@Component({
  selector: 'kt-doublon',
  templateUrl: './doublon.component.html',
  styleUrls: ['./doublon.component.scss']
})
export class DoublonComponent implements OnInit {

  id: any = "";
  doublons: any = [];
  constructor(
    public dialogRef: MatDialogRef<DoublonComponent>,
    private appService: AppService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.id = this.data.id;
    this.appService.getDoublons(this.id).subscribe((res) => {
      console.log(res);
      this.doublons = res.result;
    });
  }

  Dedoublonner(elem: any) {
    //from la ligne
    //to dossier ou je suis
    
    const confDialogRef = this.dialog.open(ConfirmComponent, {});
    confDialogRef.afterClosed().subscribe(res => {
      if(res === 'true')
        this.appService.dedoublonner(this.id, elem.ID).subscribe((res) => {
          this.dialogRef.close(true);
        });
      });
  }

  TransformToAssmat() {
    const confDialogRef = this.dialog.open(ConfirmComponent, {});
    confDialogRef.afterClosed().subscribe(res => {
      this.appService.changeTypeTier(this.id, "ASSMAT").subscribe((res) => {
        this.dialogRef.close(true);
      });
  });
  }
}
